import { create } from "zustand";

const useLoadingStore = create((set) => ({
  isLoading: false,
  loadingMessage: "",
  /**
   *
   * @param {boolean} visible - 로딩창 표시여부
   * @param {string} message - 로딩 메시지 (로딩창 종료시에는 제외해도 됨)
   */
  setIsLoading: (visible, message) => {
    set({ isLoading: visible, loadingMessage: message || "" });
  },
}));

export default useLoadingStore;
